module.exports = __webpack_public_path__ + "static/media/11.68a43b0c.png";